module.exports = __webpack_public_path__ + "images/category_lp/brand_samples/pattern_new2/sp/item_05_10dad2d0355f60c4acbb3e5dc3d8050a.jpg";